import { Injectable, Type, ViewContainerRef } from '@angular/core';
import { LogoutConfirmationModalComponent } from './logout-confirmation-modal/logout-confirmation-modal.component';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
import { StartShiftModalComponent } from '../../shift/start-shift-modal/start-shift-modal.component';
import { ActionModal } from '../../../shared/qplanning-commons/modals/action-modal.component';
import { ConfirmationModal } from '../../../shared/qplanning-commons/modals/confirmation-modal.component';

type ModalComponentType =
  | ActionModal
  | ConfirmationModal
  | LogoutConfirmationModalComponent
  | NotificationModalComponent
  | StartShiftModalComponent;

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  showConfirmationModal(
    viewContainerRef: ViewContainerRef,
    heading: string,
    text: string,
    onConfirm: Function,
    actionButtonLabel: string = 'components.zenith.action-modal.confirm'
  ) {
    const modal = this.showModal(viewContainerRef, ConfirmationModal, onConfirm, undefined);
    modal.setInput('heading', heading);
    modal.setInput('text', text);
    modal.setInput('actionButtonLabel', actionButtonLabel);
  }

  showModal<T extends ModalComponentType>(
    viewContainerRef: ViewContainerRef,
    componentType: Type<T>,
    onAction: Function,
    onCancel?: Function
  ) {
    const modal = viewContainerRef.createComponent(componentType);
    // Angular automatically cleans up event subscriptions when it destroys components with subscribers.
    modal.instance.onCancel.subscribe((data) => {
      onCancel && onCancel(data);
      modal.destroy();
    });
    modal.instance.onAction.subscribe((data) => {
      onAction(data);
      modal.destroy();
    });
    return modal;
  }

}
